import { getUseResource } from '../resource';
import { roleResources } from '../builders/roleResources';
import { IResponse } from '../models/IResponse';
import { IPage } from '../models/IPage';
import { IBasicRole } from '../models/IRole';
import { IServerSidePaginatedFetcherParams } from '../../contexts/Fetcher';

export const apiRole = {
  useListRoles: getUseResource(
    roleResources.listRoles,
    (body): IResponse<IPage<IBasicRole>> => body,
    (params, pagination: IServerSidePaginatedFetcherParams) => pagination
  ),
};
